export default __webpack_public_path__ + "static/media/Bootstrap-icon.d5210cde.png";